import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueQRCodeComponent from 'vue-qrcode-component'
import './styles/fomo-foundations.css'
import './styles/liquid-theme.css'
import './styles/fomo-buttons.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { createVuestic } from "vuestic-ui"


import "vuestic-ui/css"
import './styles/checkout-typography.css'

import JsonExcel from "vue-json-excel3"

library.add(faUserSecret)


createApp(App).use(router).use(createVuestic({
  config: {
    colors: {
      variables: {
        backgroundPrimary: '#081116',
        backgroundSecondary: '#101a20',
        primary: '#86ddd5',
        secondary: '#dff4ff',
        success: '#76d6c8',
        danger: '#cf6d58',
        warning: '#91c7dc',
        info: '#5e8ca4',
        textPrimary: '#f4f8fb',
        textInverted: '#061015',
        focus: '#bdf5f1',
      },
    },
  },
}))
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('qr-code', VueQRCodeComponent)
  .component('downloadExcel', JsonExcel)
  .mount('#app')

